import { render, staticRenderFns } from "./mpDialog.vue?vue&type=template&id=5909127c&scoped=true&"
import script from "./mpDialog.vue?vue&type=script&lang=js&"
export * from "./mpDialog.vue?vue&type=script&lang=js&"
import style0 from "./mpDialog.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./mpDialog.vue?vue&type=style&index=1&id=5909127c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5909127c",
  null
  
)

export default component.exports